import { render, staticRenderFns } from "./facebook.vue?vue&type=template&id=6449d2ab"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6449d2ab')) {
      api.createRecord('6449d2ab', component.options)
    } else {
      api.reload('6449d2ab', component.options)
    }
    module.hot.accept("./facebook.vue?vue&type=template&id=6449d2ab", function () {
      api.rerender('6449d2ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/facebook.vue"
export default component.exports